// eslint-disable-next-line jira/import-whitelist
import { fetchIssueAttachmentsSmartlinkData } from '@jira/issue__fetch-services/src/fetchIssueAttachmentsSmartlinkData.tsx';
import { createResourceError } from '@jira/router-resources__utils/src/createResourceError.tsx';
import { getIssueKey } from '@jira/router-resources__utils/src/getIssueKey.tsx';
import type { PrefetchedSmartlinkData } from '@jira/issue__fetch-services/src/fetchORSDataSSR.tsx';
import type { ResourceStoreContext, RouterDataContext } from '@atlassian/react-resource-router';

export const getIssueAttachmentsSmartlinkData = async (
	routerContext: RouterDataContext,
	storeContext: ResourceStoreContext,
): Promise<PrefetchedSmartlinkData[] | null> => {
	// Force smart link fetcher to not fire on client side to prevent CORS policy issues
	// and enable prefetching of all links should SSR resource timeout.
	if (!__SERVER__) {
		return null;
	}

	const issueKey = getIssueKey(routerContext.match);
	const { tenantContext } = storeContext;
	const cloudId = tenantContext?.cloudId;

	if (!issueKey || !cloudId) {
		return null;
	}

	try {
		return await fetchIssueAttachmentsSmartlinkData(issueKey, cloudId);
	} catch (error) {
		throw createResourceError(
			{
				component:
					'spa.view.routes.issue-view.issue-attachments-smartlink.getIssueAttachmentsSmartlinkData',
				message: 'An error was thrown while prefetching issue attachments smart link data',
			},
			error,
		);
	}
};
